import './styles/404.scss';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query {
        metadata: allProductsJson(filter: { code: { eq: "drolet_404" } }) {
            nodes {
                code
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

function NotFoundPage({ data }) {
    const { t } = useTranslation('pages');
    const { currentLocale } = usePageLocalization();
    const metadataAttributes = data?.metadata?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />

            <div className='container not-found'>
                <h1>{t('404.not-found')}</h1>
                <p>{t('404.no-route-message')}</p>
                <Button link='/'>{t('404.return-home-message')}</Button>
            </div>
        </Layout>
    );
}

export default NotFoundPage;
